import { authenticatedSchemaSubscriptionClient } from './clients';

/**
 * Disconnects the GraphQL subscriptions client (WebSocket) then let it
 * reconnect automatically. It is needed when we create a new companyProfile
 * and we need its companyProfileId to be in the context of the websocket
 * connection for authorization purposes.
 * Calling this function allows to re-trigger the "onConnect" handler on
 * graphql, thus "refreshing" the companyProfileIds in the websocket connection
 * context.
 */
export const restartGraphQLSubscriptionsWebSocket = () => {
  // We need to pass "false" to ensure the subscription client will try to
  // reconnect afterwards.
  authenticatedSchemaSubscriptionClient.close(false);
};
